import React, { useState } from 'react';
import './mobfilter.css';

import { RiSortDesc } from 'react-icons/ri';
import { AiOutlineClose } from 'react-icons/ai';
// import "jquery-ui-dist/jquery-ui";
import Form from 'react-bootstrap/Form';

import { BiFilterAlt } from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';

const MobSortV = ({sortHandle, props}) => {

    const [sortc, setSortc] = useState(false);
  const { sort, setSort } = sortHandle;


    const handelClick = (e) => {
        const id = e.target.id;
        // props.setSearch({ ...props.search, sort: id})
        setSort(id)
        setSortc(false)
    }

    return (



        <>

            <div className='sort-popup'>

                <div className='sort' onClick={() => setSortc(!sortc)}>
                    <span> <RiSortDesc /> Sort</span>
                </div>
                {
                    sortc ?
                    <div className="short-popup-bg">
                        <div className='popupshow popupshowVacancy shadow'>
                            <div className="sort-prf">
                                <span className='sort'><RiSortDesc /> Sort</span>
                                <AiIcons.AiOutlineClose onClick={() => setSortc(!sortc)} />
                            </div>
                            <hr />
                            <ul>
                                <li id='namea' onClick={handelClick}  className='sort1'>Name (A - Z)
                                    <Form.Check type="radio"  aria-label="radio 1" />
                                </li>
                                <li id='named' onClick={handelClick} className='sort1'>Name (Z - A)
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                                <li id='latest' onClick={handelClick} className='sort3'>Latest
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                                <li id='oldest' onClick={handelClick} className='sort4'>Oldest
                                    <Form.Check type="radio" aria-label="radio 1" />
                                </li>
                            </ul>


                        </div>
                        </div> : null
                }



            </div>

        </>


    )
}

export default MobSortV